import RouteList from "./routes";
function App() {
  return (
    <RouteList />
  );
}

export default App;
